import { useContext } from 'react';

import { GroupContext } from 'contexts/group/GroupContext';

export const useGroup = () => {
  const groupState = useContext(GroupContext);
  return groupState;
};
